import script from "./WorkCheckBpmnInstances.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkCheckBpmnInstances.vue?vue&type=script&setup=true&lang=js"

import "./WorkCheckBpmnInstances.vue?vue&type=style&index=0&id=21e9f550&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e9f550"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
